import L from "leaflet";

export default {
  cards: {
    map: {
      content: {
        title: "Sebaran Pondok Pesantren",
        showTitle: true,
        subtitle: "Pondok Pesantren di Indonesia",
        showSubtitle: true,
        showIcon: false,
        info: "#### Persebaran pondok pesantren di Indonesia",
        showInfo: true,
        showSaveAsImage: false,
        showTable: false,
        showDownloadTable: false,
      },
      options: {
        center: [2.0450883, 113.3616476],
        maxBounds: L.latLngBounds(
          [11.83222, 89.004448],
          [-18.680253, 153.691949]
        ),
      },
    },
  },
};
